// ----------------------------------------------------------------------------
// Animations
// ----------------------------------------------------------------------------
//
// Stores all iamota animation variation for reference into individual components.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';


// -------------------------------------
// Load Styles
// -------------------------------------

import './animations.scss';


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {
    function scrollAnimation () {
        $.fn.visible = function(partial) {
            var $t            = $(this),
                $w            = $(window),
                viewTop       = $w.scrollTop(),
                viewBottom    = viewTop + $w.height(),
                _top          = $t.offset().top + 200,
                _bottom       = _top + $t.height(),
                compareTop    = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

        var animatedComponent = $('.animate-in');

        // Already visible modules
        animatedComponent.each(function(i, el) {
            var $this = $(el);

            if ($this.visible(true)) {
                $this.addClass('already-visible');
            }
        });

        $(window).scroll(function(event) {
            animatedComponent.each(function(i, el) {
                var $this = $(el);

                if ($this.visible(true)) {
                    $this.addClass('is-animated');
                }
            });
        }), {
           capture: true,
           passive: true
        };

        $(window).scroll(function(event) {
            var $window = $(window),
                winHeight = $window.height() * 1;

            var timeline  = $('.timeline__line');
            var timelineItem = $('.timeline-item');
            var scrolled = $window.scrollTop(),
                winHeight = $window.height() * 1;

            timelineItem.each(function() {
                var $this     = $(this),
                    offsetTop = $this.offset().top + 100;

                if (scrolled + winHeight > offsetTop && offsetTop + 100 > scrolled ) {
                    var position = $this.offset().top;

                    $this.addClass('timeline-item--visible');

                }
            });
        });
    };

    scrollAnimation();
});
